import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HEADINGS_OPTIONS, NODES } from '../../../constants';
import PopupWrapper from '../../PopupWrapper';
import cx from 'classnames';
import { TextFields } from '@material-ui/icons';
import { AnimatePresence, motion } from 'framer-motion';

class Headings extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.headingClick = this.headingClick.bind(this);
    this.unwrapHeading = this.unwrapHeading.bind(this);
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  headingClick(event) {
    event.preventDefault();
    // remove all existing headings before adding a new one
    this.unwrapHeading(event);

    if (isNaN(event.currentTarget.dataset.size)) {
      this.props.editor.setBlocks(NODES.PARAGRAPH);
    } else {
      const headingSize = Number(event.currentTarget.dataset.size);
      this.props.editor.setBlocks(NODES[`HEADING_${headingSize}`]);
    }


    this.togglePopup();
  }

  unwrapHeading(event) {
    const headingSize = Number(event.currentTarget.dataset.size);
    this.props.editor.unwrapInline(NODES[`HEADING_${headingSize}`]);
  }

  render() {
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--fontsize">
          <button
            title="Headings"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
              <TextFields />
          </button>
          <AnimatePresence>
            {this.state.showPopup &&
              <motion.div
                initial={{ opacity: 0, y: '80%' }}
                animate={{ opacity: 1, y: '100%' }}
                exit={{ opacity: 0, y: '80%' }}
                transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
                className="icon__popup icon__popup--fontsize icon__popup--range">
                <ul
                  ref={ul => (this.ul = ul)}
                  className="list-reset m-0 overflow-y-scroll">
                  {HEADINGS_OPTIONS.map(size => {
                    return (
                      <li key={size}>
                        <button
                          data-size={size}
                          onClick={this.headingClick}
                          className="bg-white border-0 px-4 py-2 text-sm w-full outline-none cursor-pointer">
                          {Number(size) ? `H${size}` : size}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </motion.div>}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  Headings;
